// extracted by mini-css-extract-plugin
export default {"APPROVING":"WorkOrderChange_APPROVING__+slgE"};